module.exports = __webpack_public_path__ + "img/d- (17).b472752a.png";